import React from 'react';
import { ChevronDownIcon } from 'lucide-react';
export interface SelectOption {
  label: string;
  value: string | number;
}
interface SelectDropdownProps {
  id?: string;
  value: string | number | null;
  onChange: (value: string | number) => void;
  options: SelectOption[];
  placeholder?: string;
  error?: boolean;
}
export function SelectDropdown({
  id,
  value,
  onChange,
  options,
  placeholder,
  error
}: SelectDropdownProps) {
  // Convert null/undefined to empty string for the select value
  const selectValue = value === null || value === undefined ? '' : value;
  return <div className="relative" data-id="element-307">
      <select id={id} value={selectValue} onChange={e => onChange(e.target.value)} className={`
          w-full appearance-none bg-background border rounded-md pl-3 pr-10 py-2 text-sm shadow-sm
          focus:outline-none focus:ring-2 focus:ring-ring transition-colors cursor-pointer
          ${error ? 'border-destructive' : 'border-input'}
          ${selectValue === '' ? 'text-muted-foreground' : 'text-foreground'}
        `} aria-invalid={error} data-id="element-308">
        
        {placeholder && <option value="" disabled data-id="element-309">
            {placeholder}
          </option>}
        {options.map(opt => <option key={opt.value} value={opt.value} className="text-foreground" data-id="element-310">
            {opt.label}
          </option>)}
      </select>
      <ChevronDownIcon className="absolute right-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground pointer-events-none" data-id="element-311" />
    </div>;
}